import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className, once = true, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className={`block ${innerClassName}`}
      initial={{ y: "115%", rotate: 2 }}
      animate={{ y: 0, rotate: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, className, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
